import React from 'react';
import { Button, Tooltip } from 'antd';
import Icon from '@ant-design/icons';
import { GiBroom } from 'react-icons/gi';

const IconBroom = (props: any) => <Icon {...props} component={GiBroom} />;

export function checkHasActiveFilters(filteredInfo?: Record<string, any> | null, searchText?: string): boolean {
    if (searchText && searchText.trim() !== '') {
        return true;
    }
    if (!filteredInfo) {
        return false;
    }
    return Object.keys(filteredInfo).some((key) => {
        const value = filteredInfo[key];
        if (value === null || value === undefined) {
            return false;
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        if (typeof value === 'string') {
            return value.trim().length > 0;
        }
        return true;
    });
}

interface IBotaoLimparFiltrosProps {
    hasActiveFilters: boolean;
    onClick: () => void;
    title?: string;
    style?: React.CSSProperties;
    className?: string;
    size?: 'large' | 'middle' | 'small';
}

export const BotaoLimparFiltros: React.FC<IBotaoLimparFiltrosProps> = ({
    hasActiveFilters,
    onClick,
    title = 'Limpar filtros',
    style,
    className,
    size,
}) => {
    return (
        <Tooltip title={title} color="blue">
            <Button
                type="primary"
                size={size}
                disabled={!hasActiveFilters}
                className={className}
                style={{
                    fontSize: 20,
                    paddingTop: 0,
                    paddingBottom: 5,
                    paddingLeft: 8,
                    paddingRight: 8,
                    marginRight: 5,
                    marginBottom: 5,
                    ...style,
                }}
                onClick={onClick}
            >
                <IconBroom />
            </Button>
        </Tooltip>
    );
};

export default BotaoLimparFiltros;
